import React, { JSX } from 'react';
import ReusableLightbox from 'src/components/ReusableLightbox/reusable-lightbox';
import Avatar from 'src/components/Avatar';
import ContactCard from 'src/components/ContactCard';
import AddressInformation from 'src/components/AddressCard';
import { serviceRequestTableLocalTime } from 'src/helpers/validationHelper';
import Metrics from 'src/components/Metrics';
import MfaStatusCard from 'src/components/MfaStatusCard/MfaStatusCard';

interface BuildDetailsItemsParams {
  contactData: any;
  counts: any;
  user: any;
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  onFetchMoreDetails: () => void;
}

export const buildContactDetailsItems = ({
  contactData,
  counts,
  user,
  isOpen,
  setIsOpen,
  onFetchMoreDetails,
}: BuildDetailsItemsParams): JSX.Element[]  => {
  return [
    <div
      onClick={() =>
        setIsOpen(contactData && contactData.profileImage ? true : false)
      }
    >
      <div className="contact-details__tenant">
        <div className="contact-details__avatar">
          <Avatar size="large" url={contactData.profileImage} />
          {isOpen && isOpen === true ? (
            <ReusableLightbox
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
              image={contactData.profileImage}
            />
          ) : null}
        </div>
        <div className="contact-details__name">
          {contactData.firstname} {contactData.lastname}
        </div>
        <div className="contact-details__type">{contactData.type}</div>
      </div>
      <div style={{ textAlign: 'center' }}>
        <div className="contact-details__type">
          {contactData.status
            ? contactData.status
            : contactData.lastLoggedOn !== null
              ? 'Active'
              : '-'}
        </div>
      </div>
      {contactData.companyName ? (
        <div
          className="contact-details__type"
          style={{
            textAlign: 'center',
            paddingTop: '8px',
            color: '#3A3762',
          }}
        >
          Company:{' '}
          <span className="contact-details__type">
            {' '}
            {contactData.companyName}
          </span>
        </div>
      ) : null}
      {contactData.lastLoggedOn ? (
        <div
          className="contact-details__type"
          style={{
            textAlign: 'center',
            paddingTop: '8px',
            color: '#3A3762',
          }}
        >
          Last login:{' '}
          <span className="contact-details__type">
            {' '}
            {serviceRequestTableLocalTime(contactData.lastLoggedOn, 'contacts')}
          </span>
        </div>
      ) : null}
    </div>,
    <ContactCard contact={contactData} />,
    <AddressInformation contact={contactData} />,
    <Metrics
      items={[
        {
          key: 'Active',
          value: counts.serviceActivesCount ? counts.serviceActivesCount : 0,
        },
        {
          key: 'Archived',
          value: counts.serviceArchivedCount ? counts.serviceArchivedCount : 0,
        },
      ]}
      title={undefined}
    />,
    user.roles[0].role.name === 'Property Developer' ||
    user.roles[0].role.name === 'Strata Manager' ||
    user.roles[0].role.name === 'Service Provider' ||
    user.roles[0].role.name === 'Service Manager' ? (
      <div className="card">
        <div className="card__title">Average Estimated Time</div>
        <div className="card__body">
          <div>{counts.avgEstimatedTime}</div>
        </div>
      </div>
    ) : null,
    user.roles[0].role.name === 'Property Developer' ||
    user.roles[0].role.name === 'Strata Manager' ||
    user.roles[0].role.name === 'Service Provider' ||
    user.roles[0].role.name === 'Service Manager' ? (
      <div className="card">
        <div className="card__title">Average Actual Time</div>
        <div className="card__body">
          <div>{counts.avgActualTime}</div>
        </div>
      </div>
    ) : null,
    contactData && contactData.isSpark === true && (
      <div
        style={{ cursor: 'pointer', textDecoration: 'underline' }}
        onClick={() => onFetchMoreDetails()}
      >
        More Details
      </div>
    ),
    <MfaStatusCard contact={contactData} />,
  ];
};
